import { FC } from 'react';

import { Identicon } from '@versumstudios/ui';

import * as Styles from './styles';

export interface IAvatar {
  username?: string;
  path?: string;
  round?: boolean;
  size?: number;
}

export const Avatar: FC<IAvatar> = ({ username, path, round = true, size }) => {
  if (size) {
    return (
      <Styles.Container>
        <Styles.StyledRoot round={round} css={{ width: size, height: size }}>
          <Styles.StyledImage src={path} alt={`${username} profile`} />
          <Styles.StyledFallback delayMs={path ? 600 : 0}>
            <Identicon hash={username} />
          </Styles.StyledFallback>
        </Styles.StyledRoot>
      </Styles.Container>
    );
  }

  // adjusts to 100% parent
  return (
    <Styles.Container css={{ width: '100%' }}>
      <Styles.StyledRoot
        round={round}
        css={{
          width: '100%',
          height: '100%',
          position: 'relative',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',

          '&:after': {
            content: '',
            display: 'block',
            paddingTop: 'calc(1 * 100%);',
          },
        }}
      >
        <Styles.StyledImage src={path} alt={`${username} profile`} css={{ position: 'absolute', width: '100%' }} />
        <Styles.StyledFallback delayMs={path ? 600 : 0}>
          <Identicon hash={username} />
        </Styles.StyledFallback>
      </Styles.StyledRoot>
    </Styles.Container>
  );
};

export interface IVerified {
  size?: number;
  secondary?: boolean;
}

export const Verified: FC<IVerified> = ({ size = 14, secondary = false }) => {
  return (
    <Styles.Verified>
      <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <Styles.Path
          d="M4.78117 0.743103C5.29164 -0.247701 6.70826 -0.247701 7.21872 0.743103C7.52545 1.33846 8.21742 1.62509 8.8553 1.42099C9.91685 1.08134 10.9186 2.08304 10.5789 3.1446C10.3748 3.78247 10.6614 4.47445 11.2568 4.78117C12.2476 5.29164 12.2476 6.70826 11.2568 7.21872C10.6614 7.52545 10.3748 8.21742 10.5789 8.8553C10.9186 9.91685 9.91685 10.9186 8.8553 10.5789C8.21742 10.3748 7.52545 10.6614 7.21872 11.2568C6.70826 12.2476 5.29164 12.2476 4.78117 11.2568C4.47445 10.6614 3.78247 10.3748 3.1446 10.5789C2.08304 10.9186 1.08134 9.91685 1.42099 8.8553C1.62509 8.21742 1.33846 7.52545 0.743103 7.21872C-0.247701 6.70826 -0.247701 5.29164 0.743103 4.78117C1.33846 4.47445 1.62509 3.78247 1.42099 3.1446C1.08134 2.08304 2.08304 1.08134 3.1446 1.42099C3.78247 1.62509 4.47445 1.33846 4.78117 0.743103Z"
          css={{
            fill: secondary ? '$secondaryFill' : '$primaryFill',
          }}
        />
        <Styles.Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.43961 4.23998C8.64623 4.43922 8.65221 4.76823 8.45297 4.97484L5.40604 8.13462L3.54703 6.20676C3.34779 6.00014 3.35377 5.67113 3.56039 5.47189C3.76701 5.27266 4.09602 5.27864 4.29526 5.48525L5.40604 6.63718L7.70475 4.25334C7.90398 4.04672 8.23299 4.04074 8.43961 4.23998Z"
          css={{ fill: '$primaryBackground' }}
        />
      </svg>
    </Styles.Verified>
  );

  // return (
  //   <svg width={size} height={size} viewBox="0 0 18 18">
  //     <g fill="none" fillRule="evenodd">
  //       <path fill="#38D" fillRule="nonzero" d="M9 18A9 9 0 108.999-.001 9 9 0 009 18z" />
  //       <path stroke="#FFF" strokeWidth="2" d="M4.13 8.767l3.086 3.087 6.656-6.656" />
  //     </g>
  //   </svg>
  // );
};
